import { MonthlyPrayerTimes } from '../types';

export const julyPrayerTimes: MonthlyPrayerTimes = {
  1: {
    fajr: "02:26",
    shoruk: "03:30",
    dhuhr: "12:57",
    asr: "17:35",
    maghrib: "22:13",
    isha: "23:10"
  },
  2: {
    fajr: "02:27",
    shoruk: "03:31",
    dhuhr: "12:57",
    asr: "17:35",
    maghrib: "22:13",
    isha: "23:10"
  },
  3: {
    fajr: "02:27",
    shoruk: "03:32",
    dhuhr: "12:57",
    asr: "17:35",
    maghrib: "22:12",
    isha: "23:10"
  },
  4: {
    fajr: "02:28",
    shoruk: "03:34",
    dhuhr: "12:57",
    asr: "17:34",
    maghrib: "22:11",
    isha: "23:09"
  },
  5: {
    fajr: "02:29",
    shoruk: "03:35",
    dhuhr: "12:57",
    asr: "17:34",
    maghrib: "22:10",
    isha: "23:09"
  },
  6: {
    fajr: "02:30",
    shoruk: "03:36",
    dhuhr: "12:58",
    asr: "17:34",
    maghrib: "22:09",
    isha: "23:08"
  },
  7: {
    fajr: "02:31",
    shoruk: "03:38",
    dhuhr: "12:58",
    asr: "17:34",
    maghrib: "22:08",
    isha: "23:07"
  },
  8: {
    fajr: "02:32",
    shoruk: "03:39",
    dhuhr: "12:58",
    asr: "17:34",
    maghrib: "22:07",
    isha: "23:07"
  },
  9: {
    fajr: "02:33",
    shoruk: "03:41",
    dhuhr: "12:58",
    asr: "17:33",
    maghrib: "22:06",
    isha: "23:06"
  },
  10: {
    fajr: "02:34",
    shoruk: "03:42",
    dhuhr: "12:58",
    asr: "17:33",
    maghrib: "22:04",
    isha: "23:05"
  },
  11: {
    fajr: "02:35",
    shoruk: "03:44",
    dhuhr: "12:58",
    asr: "17:33",
    maghrib: "22:03",
    isha: "23:04"
  },
  12: {
    fajr: "02:36",
    shoruk: "03:45",
    dhuhr: "12:59",
    asr: "17:32",
    maghrib: "22:02",
    isha: "23:04"
  },
  13: {
    fajr: "02:37",
    shoruk: "03:47",
    dhuhr: "12:59",
    asr: "17:32",
    maghrib: "22:00",
    isha: "23:03"
  },
  14: {
    fajr: "02:38",
    shoruk: "03:49",
    dhuhr: "12:59",
    asr: "17:32",
    maghrib: "21:59",
    isha: "23:02"
  },
  15: {
    fajr: "02:39",
    shoruk: "03:51",
    dhuhr: "12:59",
    asr: "17:31",
    maghrib: "21:57",
    isha: "23:01"
  },
  16: {
    fajr: "02:40",
    shoruk: "03:52",
    dhuhr: "12:59",
    asr: "17:31",
    maghrib: "21:55",
    isha: "23:00"
  },
  17: {
    fajr: "02:41",
    shoruk: "03:54",
    dhuhr: "12:59",
    asr: "17:30",
    maghrib: "21:54",
    isha: "22:59"
  },
  18: {
    fajr: "02:43",
    shoruk: "03:56",
    dhuhr: "12:59",
    asr: "17:30",
    maghrib: "21:52",
    isha: "22:58"
  },
  19: {
    fajr: "02:44",
    shoruk: "03:58",
    dhuhr: "12:59",
    asr: "17:29",
    maghrib: "21:50",
    isha: "22:56"
  },
  20: {
    fajr: "02:45",
    shoruk: "04:00",
    dhuhr: "12:59",
    asr: "17:28",
    maghrib: "21:48",
    isha: "22:55"
  },
  21: {
    fajr: "02:46",
    shoruk: "04:02",
    dhuhr: "12:59",
    asr: "17:28",
    maghrib: "21:46",
    isha: "22:54"
  },
  22: {
    fajr: "02:47",
    shoruk: "04:04",
    dhuhr: "12:59",
    asr: "17:27",
    maghrib: "21:44",
    isha: "22:53"
  },
  23: {
    fajr: "02:49",
    shoruk: "04:06",
    dhuhr: "12:59",
    asr: "17:26",
    maghrib: "21:42",
    isha: "22:52"
  },
  24: {
    fajr: "02:50",
    shoruk: "04:09",
    dhuhr: "12:59",
    asr: "17:26",
    maghrib: "21:40",
    isha: "22:50"
  },
  25: {
    fajr: "02:51",
    shoruk: "04:11",
    dhuhr: "12:59",
    asr: "17:25",
    maghrib: "21:38",
    isha: "22:49"
  },
  26: {
    fajr: "02:52",
    shoruk: "04:13",
    dhuhr: "12:59",
    asr: "17:24",
    maghrib: "21:36",
    isha: "22:47"
  },
  27: {
    fajr: "02:54",
    shoruk: "04:15",
    dhuhr: "12:59",
    asr: "17:23",
    maghrib: "21:34",
    isha: "22:46"
  },
  28: {
    fajr: "02:55",
    shoruk: "04:17",
    dhuhr: "12:59",
    asr: "17:23",
    maghrib: "21:32",
    isha: "22:45"
  },
  29: {
    fajr: "02:56",
    shoruk: "04:19",
    dhuhr: "12:59",
    asr: "17:22",
    maghrib: "21:29",
    isha: "22:43"
  },
  30: {
    fajr: "02:58",
    shoruk: "04:22",
    dhuhr: "12:59",
    asr: "17:21",
    maghrib: "21:27",
    isha: "22:42"
  },
  31: {
    fajr: "02:59",
    shoruk: "04:24",
    dhuhr: "12:59",
    asr: "17:20",
    maghrib: "21:25",
    isha: "22:40"
  }
};